import React from 'react';
import { type IIconProps } from '../../dm/icons.js';

export const FootnoteIcon = ({ className, color, size }: IIconProps) => {
  return (
    <svg
      fill={color}
      width={size}
      height={size}
      viewBox="0 0 32 32"
      id="icon"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0" />
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
      <g id="SVGRepo_iconCarrier">
        <polygon points="2 7 2 9 9 9 9 25 11 25 11 9 18 9 18 7 2 7" />
        <polygon points="30 11.076 29.256 9.219 26 10.522 26 7 24 7 24 10.523 20.744 9.22 20 11.077 23.417 12.444 20.9 15.8 22.5 17 25 13.667 27.5 17 29.1 15.8 26.583 12.443 30 11.076" />
        <rect id="_Transparent_Rectangle_" fill="none" width={size} height={size} />
      </g>
    </svg>
  );
};
